import { FormGroup, Input } from '@agro-club/agroclub-shared'
import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { refetchFunc } from 'modules/domain/common/hooks'
import { RespFile } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'
import { FormGroupUpload } from 'views/components/FormGroupUpload/FormGroupUpload'
import { ASharedModal, SharedModalInputs, SharedModalTitle } from 'views/components/SharedModal'
import { SampleDetailed, SampleWithRequests } from 'views/pages/Samples/types'

type Props = {
  sample: SampleDetailed | SampleWithRequests
  refetch: refetchFunc
  onClose: () => void
}

type Fields = {
  title: string
  files: RespFile[]
}

export const EditSampleModal: FC<Props> = ({ onClose, refetch, sample }) => {
  const { t } = useTranslation('samples')
  const { formProgress, formHandler } = useAFormHandler('editSample', { id: sample.id.toString() })

  const formik = useFormik<Fields>({
    initialValues: {
      title: sample.title,
      files: sample.files,
    },

    onSubmit: formHandler(
      async () => {
        await apiClient.put(endpoints.samples(sample.id), formik.values)
      },
      {
        onSuccess: async () => {
          await refetch()
          onClose()
        },
        onError: (error) => {
          formik.setErrors(error.errors)
        },
      },
    ),
  })

  return (
    <ASharedModal size="medium" onClose={onClose} id="editSampleModal">
      <SharedModalTitle>{t('edit')}</SharedModalTitle>
      <SharedModalInputs>
        <FormGroup label={t('sampleName')} error={formik.errors.title}>
          <Input {...formik.getFieldProps('title')} invalid={!!formik.errors.title} />
        </FormGroup>
        <FormGroupUpload
          files={formik.values.files}
          maxWidthFileUpload={405}
          progress={formProgress}
          label={t('file')}
          fieldName="files"
          formik={formik}
        />
      </SharedModalInputs>
      <ADefaultModalFooter
        onConfirm={() => formik.handleSubmit()}
        confirmButtonText={t('common:save')}
        progress={formProgress}
        onClose={onClose}
      />
    </ASharedModal>
  )
}
